"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/cohort-rule/cohort-rule.js
// module id = 1249
// module chunks = 0